import { getWithAuthServerSide, putWithAuth } from './http.service';
import { GET_QUICK_QUESTIONS_URL, UPDATE_QUICK_QUESTION_URL } from './url.service';

export const getQuickQuestionByStreamId = (streamId, auth) => getWithAuthServerSide(
  GET_QUICK_QUESTIONS_URL(streamId),
  auth
);

export const updateQuickQuestion = (id, reqBody) => putWithAuth(UPDATE_QUICK_QUESTION_URL(id), reqBody);
